
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tips",
      function () {
        return require("private-next-pages/tips/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tips"])
      });
    }
  